export type MercadoPagoPreInitiateStatus = 'idle' | 'loading' | 'success' | 'error';

/**
 * `initiate` reutiliza lo que `pre-initiate` dejó en el back: sin esa consulta terminada no hay medio de pago
 * resuelto y falla. El botón espera mientras corre; si falló se habilita igual, y el submit la reintenta.
 */
export const isMercadoPagoSubmitReady = (status: MercadoPagoPreInitiateStatus): boolean =>
  status === 'success' || status === 'error';
